import request from '@/utils/request'

export function add(data) {
  return request({
    url: 'api/yumiSupplierOrderAccept',
    method: 'post',
    data
  })
}


export function updateOrderAccept(data) {
  return request({
    url: 'api/updateOrderAccept',
    method: 'post',
    data
  })
}